module.exports = __webpack_public_path__ + "static/media/venec.7f7f6945.jpg";